import styled, { css } from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    max-width: 600px;
    margin: ${theme.spacing.unit * 3}px;
    & > div > div {
      font-size: 13px;
      a {
        color: ${colors.verseBlue};
        font-weight: 600;
      }
    }

    ${media.sm`
      margin: ${theme.spacing.unit * 3}px auto;
    `}
  `}
`;

export const BannerWrapper = styled.div`
  display: flex;
  margin: auto;
  column-gap: 20px;
  flex-flow: column nowrap;

  ${media.sm`
    max-width: 600px;
    flex-flow: row nowrap;
  `}
`;

export const DlnLoader = styled.div`
  display: flex;
  justify-content: center;
  margin: 2rem 0;
`;

export const DlnWrapper = styled.div`
  #debridgeWidget {
    box-sizing: border-box;
    padding: 0px ${({ theme }) => theme.spacing.unit * 2}px;
    iframe {
      max-width: 100%;
      max-height: 700px;
    }
  }
`;
